<template>
  <div class="confirm-to-delete__container">
    <v-alert v-if="alertText" type="warning" class="mb-4">
      {{ alertText }} <strong v-if="documentName">{{ documentName }}</strong>
    </v-alert>

    <slot name="extra-alerts" />

    <p class="text-body-1 mb-4">
      {{ description }}
    </p>
    <v-checkbox v-model="isConfirmed" label="Sí, deseo continuar" />

    <v-spacer />
    <ColumnButtons
      :primary-text="confirmButtonText"
      :disable-primary="!isConfirmed"
      secondary-text="Cancelar"
      @primary-click="handleConfirm"
      @secondary-click="handleCancel"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, computed, watch } from 'vue'

import ColumnButtons from './ColumnButtons.vue'

export default defineComponent({
  name: 'ConfirmToDelete',

  components: {
    ColumnButtons,
  },

  props: {
    description: {
      type: String,
      default: '¿Estás seguro? Esta acción no se puede deshacer',
    },
    alertText: {
      type: String,
      default: 'Se eliminará',
    },
    documentName: {
      type: String as PropType<string | null>,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: 'Eliminar',
    },
  },

  emits: ['confirm', 'cancel'],

  setup(props, { emit }) {
    const isConfirmed = ref(false)
    const confirmationText = ref('')
    const hasError = ref(false)

    const alertFullText = computed(() => {
      return `${props.alertText} ${props.documentName ? `: ${props.documentName}` : ''}`
    })

    watch(
      () => confirmationText.value,
      () => {
        hasError.value = false
      },
      { immediate: true },
    )

    const resetForm = () => {
      isConfirmed.value = false
      confirmationText.value = ''
      hasError.value = false
    }

    const handleCancel = () => {
      resetForm()
      emit('cancel')
    }

    const handleConfirm = async () => {
      if (!isConfirmed.value) {
        hasError.value = true
        return
      }
      emit('confirm')
    }

    return {
      isConfirmed,
      confirmationText,
      hasError,
      alertFullText,
      handleCancel,
      handleConfirm,
    }
  },
})
</script>

<style scoped></style>
